import * as React from 'react';
import { TColors } from '@cian/ui-kit/colors';
import { MetroMoscow16, MetroSpb16 } from '@cian/ui-kit/icons';
import { isMoscowOrMO } from '../../../../utils/isMoscowOrMO';
import { isSpbOrLO } from '../../../../utils/isSpbOrLO';
import * as styles from './UndergroundIcon.css';

interface IUndergroundIconProps {
  regionId: number | null;
  lineColor: string;
}

export const UndergroundIcon: React.StatelessComponent<IUndergroundIconProps> = props => {
  const { regionId, lineColor } = props;

  if (regionId) {
    let Icon;

    if (isMoscowOrMO(regionId)) {
      Icon = MetroMoscow16;
    }

    if (isSpbOrLO(regionId)) {
      Icon = MetroSpb16;
    }

    if (Icon) {
      return (
        <div className={styles['underground-icon']} style={{ color: `#${lineColor}` }}>
          <Icon color={'currentColor' as TColors} />
        </div>
      );
    }
  }

  return <div className={styles['underground-icon--regions']} style={{ color: `#${lineColor}` }} />;
};
